export function mappingValidator() {
  return {
    duplicates: new Set(),
    mappingCount: 0,
    totalFields: 0,
    hasEmailMapping: false,
    showWarnings: false,
    duplicateFields: [],
    hasValidationIssues: false,

    selects: [],

    init() {
      this.selects = Array.from(
        document.querySelectorAll('select[name^="mappings["]'),
      );
      this.totalFields = this.selects.length;

      this.selects.forEach((select) => {
        select.addEventListener("change", () => this.validateMappings());
      });

      this.validateMappings();
    },

    validateMappings() {
      // Reset state
      this.duplicates.clear();
      this.mappingCount = 0;
      this.hasEmailMapping = false;
      this.duplicateFields = [];

      const mappingGroups = {};

      this.selects.forEach((select) => {
        const value = select.value;

        if (value && value.trim() !== "") {
          this.mappingCount++;

          // Check for email mapping
          if (value === "email") {
            this.hasEmailMapping = true;
          }

          if (!mappingGroups[value]) {
            mappingGroups[value] = [];
          }
          mappingGroups[value].push(select);
        }
      });

      Object.entries(mappingGroups).forEach(([targetField, selects]) => {
        if (selects.length > 1) {
          selects.forEach((select) => {
            select.classList.add("border-red-500", "border-2");
            this.duplicates.add(select);
          });

          const fieldName = this.getFieldDisplayName(targetField);
          this.duplicateFields.push(fieldName);
        }
      });

      this.selects.forEach((select) => {
        if (!this.duplicates.has(select)) {
          select.classList.remove("border-red-500", "border-2");
        }
      });

      this.showWarnings =
        this.duplicateFields.length > 0 || !this.hasEmailMapping;
      this.hasValidationIssues =
        this.duplicates.size > 0 || !this.hasEmailMapping;
    },

    getFieldDisplayName(value) {
      const option = document.querySelector(`option[value="${value}"]`);
      return option ? option.textContent.trim() : value;
    },
  };
}
